import React from 'react';
import { ShieldCheck, Anchor, Users, Award } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';

const SocialProof = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-white py-12 border-b border-gray-100">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div className="flex flex-col items-center gap-2 group">
            <div className="p-4 bg-primary-50 rounded-full text-primary-600 group-hover:bg-primary-100 transition-colors">
              <ShieldCheck className="w-8 h-8" />
            </div>
            <h3 className="font-bold text-primary-950">{t('socialProof.fullyInsured')}</h3>
            <p className="text-sm text-gray-500">{t('socialProof.fullyInsuredDesc')}</p>
          </div>
          
          <div className="flex flex-col items-center gap-2 group">
            <div className="p-4 bg-primary-50 rounded-full text-primary-600 group-hover:bg-primary-100 transition-colors">
              <Anchor className="w-8 h-8" />
            </div>
            <h3 className="font-bold text-primary-950">{t('socialProof.premiumFleet')}</h3>
            <p className="text-sm text-gray-500">{t('socialProof.premiumFleetDesc')}</p>
          </div>

          <div className="flex flex-col items-center gap-2 group">
            <div className="p-4 bg-primary-50 rounded-full text-primary-600 group-hover:bg-primary-100 transition-colors">
              <Users className="w-8 h-8" />
            </div>
            <h3 className="font-bold text-primary-950">{t('socialProof.expertCrew')}</h3>
            <p className="text-sm text-gray-500">{t('socialProof.expertCrewDesc')}</p>
          </div>

          <div className="flex flex-col items-center gap-2 group">
            <div className="p-4 bg-primary-50 rounded-full text-primary-600 group-hover:bg-primary-100 transition-colors">
              <Award className="w-8 h-8" />
            </div>
            <h3 className="font-bold text-primary-950">{t('socialProof.topRated')}</h3>
            <p className="text-sm text-gray-500">{t('socialProof.topRatedDesc')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
